function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.05,
  d: "M18.4 30.4C21.0667 31.3333 23.1333 32.8667 24.6 35C26.0667 37.1333 26.8 39.7333 26.8 42.8C26.8 46.8 25.5333 50.0667 23 52.6C20.4667 55.1333 17.3333 56.4 13.6 56.4C9.73333 56.4 6.53333 55.1333 4 52.6C1.46667 49.9333 0.200001 46.6667 0.200001 42.8C0.200001 40.9333 0.400001 39.0667 0.8 37.2C1.33333 35.2 2.33333 32.3333 3.8 28.6L13.2 0.599991H25.8L18.4 30.4ZM56.2 30.4C58.8667 31.3333 60.9333 32.8667 62.4 35C63.8667 37.1333 64.6 39.7333 64.6 42.8C64.6 46.8 63.3333 50.0667 60.8 52.6C58.2667 55.1333 55.1333 56.4 51.4 56.4C47.5333 56.4 44.3333 55.1333 41.8 52.6C39.2667 49.9333 38 46.6667 38 42.8C38 40.9333 38.2 39.0667 38.6 37.2C39.1333 35.2 40.1333 32.3333 41.6 28.6L51 0.599991H63.6L56.2 30.4Z",
  fill: "black"
});

var SvgQuote = function SvgQuote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 57,
    viewBox: "0 0 65 57",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuote, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote.2c20adb7.svg";
export { ForwardRef as ReactComponent };